import { useRaceUnixtime } from '../../hooks/useRaceTime';

import { Clock } from './clock';

export const RaceClock = (): JSX.Element => {
  const getRaceTime = useRaceUnixtime();

  return <Clock timeFn={getRaceTime} />;
};
